// extracted by mini-css-extract-plugin
export default {"root":"promo_codes_form_root__eVo49"};